// ============================================================================
// Supabase client factory (portable core). Ships ONLY the public URL + anon
// (publishable) key — never any server-side secret (spec §15, DEPLOYMENT.md).
// The app uses the `hanja` schema, which must be in the project's exposed
// schemas. All privileged/aggregating logic lives in SECURITY DEFINER RPCs.
// ============================================================================

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/** True when the client is configured; the UI shows setup guidance otherwise. */
export const isConfigured = Boolean(url && anonKey);

let client = null;

/** Lazily create (and memoize) the Supabase client bound to the hanja schema. */
export function getClient() {
  if (!isConfigured) {
    throw new Error(
      'Supabase is not configured. Set VITE_SUPABASE_URL and ' +
        'VITE_SUPABASE_ANON_KEY in your .env (see .env.example).'
    );
  }
  if (!client) {
    client = createClient(url, anonKey, {
      db: { schema: 'hanja' },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}
